import React from "react";

export default function CheckIcon(props: {className?: string}) {
    return <svg className={props.className ? props.className : ""} fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="12.048" height="10.184" viewBox="0 0 12.048 10.184">
    <path id="confirmed-check" d="M1518.113-1655.462l-4.53-5.234,1.512-1.309,3,3.466,6.008-7.107,1.527,1.291Z" transform="translate(-1513.583 1665.646)"/>
  </svg>
;  
}